// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"0387ebe47c3aad5b","4990":"474202c6c20f30ee"}[chunkId] + ".css";
};